import { isMobile } from "../../common/utils.js";
import { MpVideoPlayer } from "../../common/video_player.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const multiJWP = new MpVideoPlayer();
	multiJWP.init().then((is_ready) => {
		if (!isMobile()) {
			import("jquery").then((jQuery) => {
				const $ = jQuery.default;
				import("bootstrap/js/dist/tooltip").then(() => {
					// Tooltip voti
					$(".gamecard__vote > div").tooltip();
				});
			});
		}
		// Comment count
		for (const article of document.querySelectorAll("._comments_number")) {
			if (article.dataset.ct && article.dataset.id) {
				fetch(
					`/misc/comments_counter/${article.dataset.ct}/${article.dataset.id}/`,
					{
						headers: {
							"X-Requested-With": "XMLHttpRequest",
						},
						cache: "no-cache",
					},
				)
					.then((response) => response.json())
					.then((data) => {
						if (Number.parseInt(data.comment_count) > 149) {
							article.textContent = "HOT";
							article.classList.add("hot");
						} else {
							article.textContent = data.comment_count;
						}
					})
					.catch((error) => {
						console.warn(error);
					});
			}
		}
	});
});
